<div *ngIf="loading; else notLoading" class="progress w-100 fade-in">
  <div class="progress-bar progress-bar-striped bg-success progress-bar-animated w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
</div>
<ng-template  #notLoading>
  <div class="progress w-100 fade-out" (animationend)="loading = false" *ngIf="loading;">
    <div class="progress-bar progress-bar-striped bg-success progress-bar-animated w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</ng-template>
